var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecarbonization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5C7.2 3.5 3 7.36 3 12.5C3 14.62 3.74 16.57 4.97 18.11L3 20.09L4.41 21.5L6.38 19.53C7.93 20.76 9.88 21.5 12 21.5C14.3 21.5 16.61 20.62 18.36 18.86C20.12 17.11 21 14.8 21 12.5V3.5H12ZM19 12.5C19 14.37 18.27 16.13 16.95 17.45C15.63 18.77 13.87 19.5 12 19.5C8.14 19.5 5 16.36 5 12.5C5 10.6 5.74 8.82 7.1 7.51C8.42 6.21 10.16 5.5 12 5.5H19V12.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46 13.13L12.51 13.53L10.07 16.86C9.96 17.02 9.97 17.24 10.11 17.38C10.26 17.53 10.51 17.54 10.67 17.39L15.83 12.76C16.16 12.46 15.98 11.91 15.53 11.87L11.48 11.47L13.92 8.14C14.03 7.98 14.02 7.76 13.88 7.62C13.73 7.47 13.48 7.46 13.32 7.61L8.16 12.24C7.84 12.54 8.02 13.09 8.46 13.13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecarbonization);
export default __webpack_public_path__ + "static/media/decarbonization.0e95f8e85b80e6c9b5f4d15d2c009e23.svg";
export { ForwardRef as ReactComponent };